export default function OrbitGrid({ stocks = [], onSelectStock }) {
  return (
    <div className="oc-grid">
      {stocks.map((s, i) => {
        const isUp = s.direction === 'up';
        return (
          <div key={i} className="oc">
            <div className="oc-top">
              <div>
                <div className="oc-sym" onClick={() => onSelectStock?.(s.sym)}>{s.sym}</div>
                <div className="oc-name">{s.name}</div>
              </div>
              <span style={{ fontFamily: 'var(--fm)', fontSize: 14, fontWeight: 500, color: isUp ? 'var(--green)' : 'var(--red)' }}>
                {s.change}
              </span>
            </div>
            <div className="oc-why">{s.relation}</div>
            <div className="oc-desc">{s.desc}</div>
            <span
              className="oc-sig"
              style={{ background: s.signalBg ?? 'var(--amber-s)', color: s.signalColor ?? 'var(--amber)' }}
            >
              {s.signalLabel}
            </span>
          </div>
        );
      })}
    </div>
  );
}
